import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import style from './delete-filterview-modal.module.less';

export const DeleteFilterViewModal = ({ modalFrameworkMethods, filterViewToDelete, deleteFilterViewRequest }) => {
  const { closeModal } = modalFrameworkMethods;
  const { displayName } = filterViewToDelete;
  return (
    <Modal className={style['delete-filterview-modal']}>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Delete View' description='deleteFilterViewModal.title' id='pyAXu4' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['modal-text']}>
          <FormattedMessage
            defaultMessage='Are you sure you want to delete the view {viewName}? This action cannot be done.'
            description='deleteFilterViewModal.prompt'
            id='xYZNHI'
            values={{ viewName: <b>{displayName}</b> }}
          />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button className={style['cancel-button']} onClick={closeModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='deleteFilterViewModal.cancel' id='N42XNu' />
        </Button>
        <Button
          onClick={() => {
            deleteFilterViewRequest(filterViewToDelete);
          }}
          theme='primary'
        >
          <FormattedMessage defaultMessage='Delete View' description='deleteFilterViewModal.saveView' id='+LlzWm' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteFilterViewModal.propTypes = {
  deleteFilterViewRequest: PropTypes.func.isRequired,
  filterViewToDelete: PropTypes.object.isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
